module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-1.0112c4ad.svg";